/* eslint-disable no-console, no-alert, no-unused-vars */
import EzController from 'controllers/ez-base-controller';
import { FORM_ERROR, FORM_FIELD_FOCUS } from 'components/analytics/conversions/constants/actions';
import {
  findCategoryByElement,
  sendTrackingEvent,
} from 'components/analytics/conversions/tracking';

export default class FormAnalyticsontroller extends EzController {
  declare readonly errorFieldTarget: HTMLElement;

  declare readonly errorFieldTargets: HTMLElement[];

  declare readonly hasErrorFieldTarget: boolean;

  static targets = [
    'errorField',
  ];

  connect() {
    if (this.hasErrorFieldTarget) {
      this.errorFieldTargets.forEach((errorField) => {
        this.sendFormFieldErrorEvent(errorField);
      });
    }
  }

  sendFormFieldFocusEvent = (event) => {
    const englishLabelValue:string = event.currentTarget.dataset.englishLabel;

    sendTrackingEvent({
      element: event.currentTarget,
      data: {
        action: FORM_FIELD_FOCUS,
        category: findCategoryByElement(event.currentTarget),
        label: `Field-${englishLabelValue}`,
      },
    });
  }

  sendFormFieldErrorEvent = (errorField) => {
    const englishLabelValue:string = errorField.dataset.englishLabel;

    sendTrackingEvent({
      element: errorField,
      data: {
        action: FORM_ERROR,
        label: `Field-${englishLabelValue}`,
        category: findCategoryByElement(errorField),
        error_trigger: 'Error-Submission',
      },
    });
  }
}
